function Comp34() {
    var swiper = new Swiper(".comp-34 .swiper", {
        loop: true,
        effect: "fade",
        navigation: {
            nextEl: ".comp-34 .btn-circle:last-child",
            prevEl: ".comp-34 .btn-circle:first-child",
        },
    });
}
Comp34();
